<div class="powerbi-container">
    <iframe title="CPPIB - Q1 2025" width="1500" height="560"
        src="https://app.powerbi.com/reportEmbed?reportId=a6b8b69c-6d3b-4c4d-9ef7-5a3605113275&autoAuth=true&ctid=46c5178e-a0f4-4f4d-8c40-9598e3d11860"
        frameborder="0" allowfullscreen="true">
    </iframe>
</div>